import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  contactDetails,
  footerLinks,
  productLinks,
  socialLinks,
} from "../data/siteContent";

function SiteFooter() {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [newsletterMessage, setNewsletterMessage] = useState("");

  const getInternalHref = (href) => {
    if (!href.startsWith("#")) {
      return href;
    }

    return location.pathname === "/" ? href : `/${href}`;
  };

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();

    if (!email.trim()) {
      setNewsletterMessage(
        "Enter your email address to request newsletter updates."
      );
      return;
    }

    const subject = encodeURIComponent("Newsletter subscription");
    const body = encodeURIComponent(
      `Hello Operating Software,\n\nPlease add ${email} to your newsletter updates.\n`
    );

    window.location.href = `mailto:${contactDetails.email}?subject=${subject}&body=${body}`;
    setNewsletterMessage(
      "Your email app has been opened so you can complete the subscription request."
    );
    setEmail("");
  };

  return (
    <footer id="footer" className="footer">
      <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-6">
              <h4>Join Our Newsletter</h4>
              <p>
                Stay close to our latest product updates, client work, and
                company news.
              </p>
              <form onSubmit={handleNewsletterSubmit} className="php-email-form">
                <div className="newsletter-form">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="Your email address"
                    aria-label="Email address"
                  />
                  <input type="submit" value="Subscribe" />
                </div>
                {newsletterMessage ? (
                  <div className="sent-message contact-status visible">
                    {newsletterMessage}
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href={getInternalHref("#hero")} className="d-flex align-items-center">
              <span className="sitename">OS Ltd</span>
            </a>
            <div className="footer-contact pt-3">
              <p>Thika - Mang'u Road</p>
              <p>Thika West Center</p>
              <p className="mt-3">
                <strong>Phone:</strong> <span>{contactDetails.phone}</span>
              </p>
              <p>
                <strong>Email:</strong> <span>{contactDetails.email}</span>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="footer-links">
              <h4>Useful Links</h4>
              <ul>
                {footerLinks.map((link) => (
                  <li key={link.text}>
                    <i className="bi bi-chevron-right"></i>
                    <a href={getInternalHref(link.href)}>{link.text}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="footer-links">
              <h4>Featured Projects</h4>
              <ul>
                {productLinks.map((link) => (
                  <li key={link.text}>
                    <i className="bi bi-chevron-right"></i>
                    <a
                      href={getInternalHref(link.href)}
                      target={link.href.startsWith("http") ? "_blank" : undefined}
                      rel={
                        link.href.startsWith("http")
                          ? "noopener noreferrer"
                          : undefined
                      }
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <h4>Follow Us</h4>
            <p>
              Follow Operating Software for product updates, company news, and
              behind-the-scenes progress on what we are building.
            </p>
            <div className="social-links d-flex">
              {socialLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                >
                  <i className={`bi ${link.icon}`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>
          <strong className="px-1 sitename">Operating Software</strong>
          <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;
